// utils/settings.js
import { supabase } from '../lib/supabase';

export async function getYoutubeUrl() {
  const { data, error } = await supabase
    .from('settings')
    .select('value')
    .eq('key', 'youtube_url')
    .single();
  return data?.value || '';
}

export async function setYoutubeUrl(url) {
  const { error } = await supabase
    .from('settings')
    .upsert({ key: 'youtube_url', value: url }, { onConflict: ['key'] });
  return error == null;
}
